import { ENROLLMENT_STATUS, type PageName } from "consts";
import { usePolicyDetail } from "data/ss-data-hooks";

import { PaperlessCardEnrolled } from "./paperless-card-enrolled";
import { PaperlessCardUnenrolled } from "./paperless-card-unenrolled";

type PaperlessCardProps = {
  pageName: PageName;
};

/**
 * Show an enrolled or unenrolled card if the policy is active and not commercial.
 */
export const PaperlessCard = ({ pageName }: PaperlessCardProps) => {
  const { data } = usePolicyDetail();

  if (
    data?.userDetails.policyStatus !== "ACTIVEPOLICY" ||
    data?.userDetails.isCommercial
  ) {
    return null;
  }

  const enrolled =
    data?.userDetails.insuredPreferences?.paperlessDocumentEnrollmentStatus ===
    ENROLLMENT_STATUS.ENROLLED;

  return enrolled ? (
    <PaperlessCardEnrolled />
  ) : (
    <PaperlessCardUnenrolled pageName={pageName} />
  );
};
